import { eTipoPermissao } from '@/enums/ePermissoes';

/*
 * As mesmas duas views também são abertas pelo menu do ACADÊMICO, com permissão própria
 * (src/routes/academico/cadastrofuncionarios). Elas se encontram pela `meta.rotaListagem` /
 * `meta.rotaCadastro` da rota corrente, e não por nome fixo — ver docs/pessoal/README.md.
 */
export default [
  {
    description: 'Servidor',
    path: '/pessoal/pesservidor',
    name: 'pesservidor',
    component: () => import('@/views/pessoal/pesservidor/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.SERVIDORNOVO_MENU_1400100199],
      rotaListagem: 'pesservidor',
      rotaCadastro: 'pesservidor_create',
    },
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Servidor',
    path: '/pessoal/pesservidor/cadastro/:id?',
    parent: 'pesservidor',
    name: 'pesservidor_create',
    component: () => import('@/views/pessoal/pesservidor/InclusaoEdicao.vue'),
    meta: {
      permissions: [eTipoPermissao.SERVIDORNOVO_MENU_1400100199],
      rotaListagem: 'pesservidor',
      rotaCadastro: 'pesservidor_create',
    },
    goesToMenu: true,
  },
];
